module.exports = __webpack_public_path__ + "img/home-icon-silhouette.763b1261.svg";